import { Outlet, useLocation } from 'react-router-dom';

import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';
import useIsMobile from '@/hooks/useIsMobile';

import SideButton from '../common/Button/SideButton';
import Modal from '../common/Modal/Modal/Modal';
import ScrollToTop from '../common/ScrollToTop/scrollToTop';
import Toast from '../common/Toast/Toast';

const Layout = () => {
	const { pathname } = useLocation();
	const isMobile = useIsMobile(900);
	return (
		<>
			<Modal />
			<Toast />
			<ScrollToTop />

			<Header />
			<Outlet />
			{(pathname !== '/mypage' || !isMobile) && <Footer />}

			<SideButton />
		</>
	);
};

export default Layout;
